import SystemPromptsTable from "./components/sytem-prompts-tables/systemPromptsTable";

const SystemPromptTables = () => {
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <SystemPromptsTable />
      </div>
    </div>
  );
};

export default SystemPromptTables;
